import React, { Component, Fragment } from 'react';
import axios from 'axios'

import { 
  Modal, 
  Row,
  Col,
  Button, 
  Switch,
  Space,
  Table,
  Input 
} from 'antd';
import { SearchOutlined, StarOutlined, StarFilled, CloseOutlined } from '@ant-design/icons';

import { authService } from '../../services/authService';
import { API_BASE_URL } from '../../config/api';

class TestsModal extends Component {
  constructor(props){
    super(props);
    this.state = {
      clientID: props.client.id,
      clientCode: props.client.ClientCode,
      open: false,
      searchText: '',
      showFavorites: false,

      allData: [],
      favoritesData: [],

      loading: false,
      skip: 0,
      limit: 10,
      currentPage: 1,
      totalCount: 0,
    };
  }

  onClickModal = () => {
    this.setState(prev => {
      const nextOpen = !prev.open;

      if (nextOpen) {
        return { open: true, searchText: '', showFavorites: false };
      }

      return { open: false, searchText: '' };
    }, () => {
      if (this.state.open) {
        this.setState({ currentPage: 1, skip: 0, searchText: '' }, () => {
          this.loadFavTests({ q: '', page: 1, applyState: false }).then(({ items, totalCount }) => {
              if (totalCount > 0) {
                this.setState({
                  favoritesData: items,
                  totalCount,
                  showFavorites: true,
                  loading: false,
                });
              } else {
                this.setState({ showFavorites: false }, () => {
                  this.loadTests({ q: '', page: 1, applyState: true });
                });
              }
            }).catch(() => {
              this.setState({ showFavorites: false }, () => {
                this.loadTests({ q: '', page: 1, applyState: true });
              });
            });
        });
      } else {
        this.props.mappingTests(this.props.selectedTests);
      }
    });
  };

  applySearch = () => {
    this.setState({ currentPage: 1, skip: 0 }, () => {
      if (this.state.showFavorites) return this.loadFavTests();
      return this.loadTests();
    });
  };

  loadTests = async ({q = this.state.searchText, page = this.state.currentPage, pageSize = this.state.limit, applyState = true} = {}) => {
    const skip = (page - 1) * pageSize;
    this.setState({ loading: true });

    const token = await authService.ensureValidToken();
    if (!token) {
      console.error('Not authenticated');
      return;
    }

    const params = {
      skip: skip,
      limit: pageSize,
      q: this.state.searchText
    };

     return axios({
      method: 'GET',
      url: `${API_BASE_URL}/connect/orderSets`,
      params: params,
      headers: { Authorization: `Bearer ${token}` },
    }).then(res => {
      const items = res.data.items || [];
      const totalCount = res.data.totalCount ?? res.data.total ?? 0;

      if (applyState) {
        this.setState({
          allData: items,
          totalCount,
          skip,
          limit: pageSize,
          currentPage: page,
          loading: false,
        });
      } else {
        this.setState({ loading: false });
      }

      return { items, totalCount };
    })
    .catch(err => {
      console.log(err);
      this.setState({ loading: false });
      throw err;
    });
  };

  loadFavTests = async ({ q = this.state.searchText, page = this.state.currentPage, pageSize = this.state.limit, applyState = true } = {}) => {
    const skip = (page - 1) * pageSize;
    this.setState({ loading: true });

    const token = await authService.ensureValidToken();
    if (!token) {
      console.error('Not authenticated');
      return;
    }

    const params = {
      skip: skip,
      limit: pageSize,
      clientID: this.state.clientID,
      q: this.state.searchText
    };

     return axios({
      method: 'GET',
      url: `${API_BASE_URL}/connect/orderSets/favorites`,
      params: params,
      headers: { Authorization: `Bearer ${token}` },
    }).then(res => {
      const items = res.data.items || [];
      const totalCount = res.data.totalCount ?? res.data.total ?? 0;

      if (applyState) {
        this.setState({
          favoritesData: items,
          totalCount,
          skip,
          limit: pageSize,
          currentPage: page,
          loading: false,
        });
      } else {
        this.setState({ loading: false });
      }

      return { items, totalCount };
    })
    .catch(err => {
      console.log(err);
      this.setState({ loading: false });
      throw err;
    });
  };

  handlePageChange = (page, pageSize) => {
    const nextPage = pageSize !== this.state.limit ? 1 : page;

    this.setState({ currentPage: nextPage, limit: pageSize }, () => {
      const q = this.state.searchText || '';
      if (this.state.showFavorites) {
        this.loadFavTests({ q, page: nextPage, pageSize });
      } else {
        this.loadTests({ q, page: nextPage, pageSize });
      }
    });
  };

  handleSearchChange = (e) => {
    const value = e.target.value;
    this.setState({
      searchText: value
    })
  };  

  handleToggleFavorites = (checked) => {
    this.setState(
      { showFavorites: checked, searchText: '', currentPage: 1, skip: 0 },
      () => {
        if (checked) this.loadFavTests({ q: '', page: 1 });
        else this.loadTests({ q: '', page: 1 });
      }
    );
  };

  isFavorite = (record) => this.state.favoritesData.some(item => item.code === record.code);

  addToFavorites = async (record) => {
    this.setState(prev => {
      if (prev.favoritesData.some(dx => dx.code === record.code)) return null;

      return {
        favoritesData: [...prev.favoritesData, record],
      };
    });
    const token = await authService.ensureValidToken();
    if (!token) {
      console.error('Not authenticated');
      return;
    }
    let formData = {
      clientID: this.state.clientID, 
      clientCode: this.state.clientCode, 
      orderSetID: record.id, 
      code: record.code, 
      description: record.description
    }

     axios({
      method: 'POST',
      url: `${API_BASE_URL}/connect/orderSets/favorites`,
      data: formData,
      headers: { Authorization: `Bearer ${token}` },
    }).catch(err => {
      console.log(err);
      this.setState(prev => ({
        favoritesData: prev.favoritesData.filter(dx => dx.code !== record.code),
      }));
    });
  };

  removeFromFavorites = async (record) => {
    this.setState(prev => {
      const nextFavs = prev.favoritesData.filter(dx => dx.code !== record.code);
      return {
        favoritesData: nextFavs,
      };
    });
    const token = await authService.ensureValidToken();
    if (!token) {
      console.error('Not authenticated');
      return;
    }
    let formData = {
      clientID: this.state.clientID, 
      clientCode: this.state.clientCode, 
      orderSetID: record.orderSetID, 
      code: record.code,
    }

     axios({
      method: 'DELETE',
      url: `${API_BASE_URL}/connect/orderSets/favorites`,
      data: formData,
      headers: { Authorization: `Bearer ${token}` },
    }).catch(err => {
      console.log(err);
      this.setState(prev => ({
        favoritesData: [...prev.favoritesData, record],
      }));
    });
  };

  handleSelectTests = (record) => {
    const { onSelectTest } = this.props;
    if (onSelectTest) {
      onSelectTest(record);
    }
  };

  isSelected = (record) => {
    const { selectedTests = [] } = this.props;
    return selectedTests.some(test => test.code === record.code);
  };

  render() {
    const {
      open,
      allData,
      favoritesData,
      searchText,
      loading,
      showFavorites
    } = this.state;

    const dataSource =
      showFavorites
        ? favoritesData
        : allData;

    const columns = [
      { title: 'Code', dataIndex: 'code', key: 'code', width: 110 },
      { title: 'Description', dataIndex: 'description', key: 'description' },
      {
        title: '',
        key: 'favorite',
        width: 40,
        align: 'center',
        render: (_, record) => {
          const isFav = this.isFavorite(record);

          return (
            <Button
              type="text"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                isFav
                  ? this.removeFromFavorites(record)
                  : this.addToFavorites(record)
              }}
            >
              {isFav ? (
                <StarFilled style={{ color: '#faad14' }} />
              ) : (
                <StarOutlined />
              )}
            </Button>
          );
        },
      }
    ];

    const columns2 = [
      {
        title: 'Code',
        dataIndex: 'code',
        key: 'code',
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
      },
      {
        title: 'Action',
        key: 'action',
        render: (_, record) => (
          <Space size="middle">
            <Button
              danger
              size="small"
              onClick={() => this.props.handleRemoveTest(record.code)}
            >
              <CloseOutlined />
            </Button>
          </Space>
        ),
      },
    ];

    return (
      <Fragment>
        <Button type="primary" ghost size="small" block onClick={this.onClickModal}>
          <SearchOutlined /> Search Tests
        </Button>

        <Modal
          title="Search Tests"
          centered
          open={open}
          onOk={this.onClickModal}
          onCancel={this.onClickModal}
          width="80%"
        >
          <Row>
            <Col span={12}>
              <Space style={{ marginBottom: 8, width: '100%', justifyContent: 'space-between' }}>
                <Input.Search
                  placeholder="Search by code or description"
                  allowClear
                  value={searchText}
                  onChange={this.handleSearchChange}
                  onSearch={this.applySearch}
                  style={{ maxWidth: 400 }}
                />

                <Switch
                  size="small"
                  checkedChildren="Favorites"
                  unCheckedChildren="All"
                  checked={showFavorites}
                  onChange={this.handleToggleFavorites}
                />
              </Space>

              <div style={{overflowY: 'auto', height: this.state.showFavorites ? '500px' : 'auto'}}>
                <Table
                  columns={columns}
                  dataSource={dataSource}
                  loading={loading}
                  size="small"
                  rowKey={(row) => row.id}
                  onRow={(record) => ({
                    onClick: () => this.handleSelectTests(record),
                    style: { cursor: 'pointer' },
                  })}
                  rowClassName={(record) =>
                    this.isSelected(record) ? 'dx-row-selected' : ''
                  }
                  pagination={!this.state.showFavorites ? {
                    current: this.state.currentPage,
                    pageSize: this.state.limit,
                    total: this.state.totalCount,
                    showSizeChanger: true,
                    pageSizeOptions: ['10', '25', '50', '100'],
                    onChange: this.handlePageChange,
                    onShowSizeChange: this.handlePageChange,
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
                  }:false}
                />
              </div>
            </Col>
            <Col span={12}>
              <br/><br/>
              <Table
                className="diagnosis-table"
                columns={columns2}
                dataSource={this.props.selectedTests}
                size="small"
                rowKey="code"
                showHeader={false}
              />
            </Col>
          </Row>
                    
        </Modal>
      </Fragment>
    );
  }
}

export default TestsModal;
